module.exports = __webpack_public_path__ + "img/inu_gallery11.babb7d89.jpg";